<template>
  <el-tabs v-model="activeName" class="tabs">
    <el-tab-pane name="first" label="电脑端" class="mineCon">
      <div class="help">
        <p>登录状态下，进入【医生预约页面】</p>
        <p><strong>优惠券：</strong>点击【领取】，即可领取成功</p>
        <img src="../../../assets/userImg/coupon_a.png" alt="">
        <p><strong>月/年卡：</strong>点击【购买】，弹出支付二维码弹窗，使用微信扫一扫支付</p>
        <img src="../../../assets/userImg/coupon_b.png" alt="">
        <p><strong>【私信领取优惠券】</strong></p>
        <p><strong>第一步：</strong>在【私信消息】页面中，找到医生，点击医生发送的优惠券链接，进入【优惠券领取】网页</p>
        <img src="../../../assets/userImg/chat_c.png" alt="">
        <p><strong>第二步：</strong>在【领取优惠券】网页中，点击【领取】按钮，即领取成功，保存至【我的优惠券】中，在优惠券有效期内用于咨询预约</p>
        <img src="../../../assets/userImg/chat_d.png" alt="">
      </div>
    </el-tab-pane>
  </el-tabs>

</template>

<script>
export default {
  name: "coupon",
  data() {
    return {activeName: 'first'}
  },
  mounted() {
  },
  methods: {},
}
</script>

<style lang="scss" scoped>
@import "../../../assets/css/help";
</style>
